module.exports = __webpack_public_path__ + "img/no-img.36bbc8aa.jpg";